import { format, formatDistanceToNow, isValid, parse, parseISO } from "date-fns";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "src/components/ui/hover-card";

export const TIME_MARKER = "§";

export function TimeMarker({ children }: { children: string }) {
  // Try to parse the timestamp in multiple formats
  let timestamp: Date | null = null;
  
  // Try ISO format first
  try {
    timestamp = parseISO(children);
  } catch {
    // Parsing failed, continue to next method
  }
  
  // If that didn't work, try parsing with UTC suffix
  if (!timestamp || !isValid(timestamp)) {
    try {
      timestamp = parse(children, "yyyy-MM-dd HH:mm:ss 'UTC'", new Date());
    } catch {
      // Parsing failed, continue to next method
    }
  }
  
  // Try other common formats
  if (!timestamp || !isValid(timestamp)) {
    const formats = [
      "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
      "yyyy-MM-dd'T'HH:mm:ssxxx",
      "yyyy-MM-dd HH:mm:ss",
      "yyyy-MM-dd",
    ];
    
    for (const formatStr of formats) {
      try {
        timestamp = parse(children, formatStr, new Date());
        if (isValid(timestamp)) break;
      } catch {
        // Parsing failed, continue to next format
      }
    }
  }

  // Check if the timestamp is valid
  if (!timestamp || !isValid(timestamp)) {
    return <span>{children}</span>;
  }

  // Check if it's just a date (no time component)
  if (children.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return <span>{children}</span>;
  }

  return (
    <HoverCard openDelay={50} closeDelay={50}>
      <HoverCardTrigger asChild>
        <span className="time cursor-help">{children}</span>
      </HoverCardTrigger>
      <HoverCardContent className="w-fit">
        <div className="flex flex-col gap-1 text-sm">
          <div>Local: {format(timestamp, "yyyy-MM-dd hh:mm a")}</div>
          <div className="text-muted-foreground text-xs">({formatDistanceToNow(timestamp, { addSuffix: true })})</div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}